import { useNavigate } from 'react-router-dom';

import { Button, Group, Stack, Text } from '@ekhodealer/ekho-common/rev';

import { ProductUpgradeOverlay } from '@common/components/ProductUpgradeOverlay';
import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { useProductAccess } from '@common/hooks/useProductAccess';
import { ConversationsLayout } from '@features/conversations/components/ConversationsLayout';
import { ConversationStats } from '@features/conversations/components/ConversationStats';
import { paths } from '@config/paths';
import { SettingsSection } from '@config/paths/settingsSections';

import './ConversationsPage.scss';

function ConversationsPage() {
	const navigate = useNavigate();
	const servicesProviderId = useCurrentServicesProviderId();
	const { hasAccess, isLoading } = useProductAccess('aiBdc');

	const handleSettingsClick = (): void => {
		navigate(paths.settingsSection.getHref(servicesProviderId, SettingsSection.ProductsAiBdc));
	};

	return (
		<div className='conversations-page'>
			<Stack itemsSpacing='12' padding={{ bottom: 12 }}>
				<Group itemsAlignX='space-between' itemsAlignY='center'>
					<Group.Item>
						<Text size='heading' weight='bold'>
							AI BDC
						</Text>
					</Group.Item>
					{hasAccess && (
						<Group.Item>
							<Button variant='secondary' size='small' onPress={handleSettingsClick}>
								Settings
							</Button>
						</Group.Item>
					)}
				</Group>
				<ConversationStats />
			</Stack>
			<ConversationsLayout />
			{!isLoading && !hasAccess && <ProductUpgradeOverlay moduleId='aiBdc' />}
		</div>
	);
}

export default ConversationsPage;
